import type { FormInstance } from "antd";
import { useTranslation } from "react-i18next";
import { CustomTypography } from "sipli-fleet-core/components";
import CustomerFormField from "../CustomerFormField";
import type { CustomerSelectLookups } from "../CustomerTabs";

const InvoiceSettings = ({
  form: _form,
  selectLookups,
}: {
  form: FormInstance;
  selectLookups: CustomerSelectLookups;
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-8">
      <CustomTypography.CustomTitle className="!text-[17.72px] !font-bold">
        {t("invoice_settings")}
      </CustomTypography.CustomTitle>
      <div className="grid grid-cols-2 mt-7 gap-x-3">
        <CustomerFormField
          name="invoiceVat"
          label={t("vat")}
          placeholder={t("select")}
          className="!h-[32px] !rounded-[4px]"
          options={selectLookups.vatOptions}
          disabled
        />
        <CustomerFormField
          name="invoiceCountry"
          label={t("country")}
          placeholder={t("select")}
          className="!h-[32px] !rounded-[4px]"
          options={selectLookups.countryOptions}
          loading={selectLookups.countryLoading}
          disabled
        />
        <CustomerFormField
          name="paymentType"
          label={t("payment_type")}
          placeholder={t("select")}
          className="!h-[32px] !rounded-[4px]"
          options={selectLookups.paymentTypeOptions}
          loading={selectLookups.paymentTypeLoading}
          disabled
        />
        <CustomerFormField
          name="paymentPeriod"
          label={t("payment_period")}
          placeholder={t("select")}
          className="!h-[32px] !rounded-[4px]"
          options={selectLookups.paymentOptions}
          loading={selectLookups.paymentLoading}
          disabled
        />
        <CustomerFormField
          name="paySubscriptionUntil"
          label={t("pay_subscription_until")}
          placeholder={t("select")}
          className="!h-[32px] !rounded-[4px]"
          options={selectLookups.paymentSubsUnitOptions}
          loading={selectLookups.paymentSubsUnitLoading}
          disabled
        />
        <CustomerFormField
          name="pprPaymentTerm"
          label={t("ppr_payment_term")}
          placeholder={t("select")}
          className="!h-[32px] !rounded-[4px]"
          options={selectLookups.pprPaymentTermOptions}
          loading={selectLookups.pprPaymentTermLoading}
          disabled
        />
        {/* <CustomerFormField name="invoiceVatNr" className="!h-[32px] !rounded-[4px]" label={t("vat_nr")} placeholder={t("type")} />
        <CustomerFormField name="invoiceBank" className="!h-[32px] !rounded-[4px]" label={t("bank")} placeholder={t("type")} /> */}
      </div>
    </div>
  );
};

export default InvoiceSettings;
